import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { getMockHomeworkSession, hasMockHomeworkBinding } from '@/utils/homeworkSession';
import { PointsActions } from '@/stores/slice/pointsSlice';
import store, { useAppSelector } from '@/stores';
import { fetchUserPoints2, getStudentInfoAsync } from '@/stores/slice/user';
import MockStart from './subPage/MockStart';
import MockListening from './subPage/MockListening';
import MockReading from './subPage/MockReading';
// import MockWritingAI from './subPage/MockWritingAI';
import MockWriting from './subPage/MockWriting';
import { Redirect } from './components/Redirect';
import ClientExamGuard from './components/ClientExamGuard';
import PracticeLaunch from './PracticeLaunch';
import './index.less';


// /:id
function App() {
  const navigate = useNavigate();
  const scoped = getMockHomeworkSession();
  const routerConf = React.useMemo(() => {
    return [
      { path: '/launch', Component: PracticeLaunch },
      { path: '/teacher-launch', Component: PracticeLaunch },
      { path: '/practice-launch/:ticket', Component: PracticeLaunch },
      { path: '/mockstart/:recordId', Component: MockStart },
      { path: '/mocklistening/:recordId', Component: () => <ClientExamGuard course="listening"><MockListening /></ClientExamGuard>},
      { path: '/mocklisteningai/:recordId', Component: MockListening},
      { path: '/mockreading/:recordId', Component: () => <ClientExamGuard course="reading"><MockReading /></ClientExamGuard>},
      { path: '/mockreadingai/:recordId', Component: MockReading},
      { path: '/mockwriting/:recordId', Component: () => <ClientExamGuard course="writing"><MockWriting /></ClientExamGuard>},
      { path: '/mockwritingai/:recordId', Component: MockWriting},
      { path: '/*', loader: () => <></>, Component: Redirect },
    ];
  }, []);

  const isLogin = useAppSelector(state => state.user.userPermission.isLogin);

  useEffect(() => {
    if (!/^#\/(?:launch|teacher-launch|practice-launch)(?:[/?]|$)/.test(window.location.hash)) store.dispatch(getStudentInfoAsync());
  }, []);

  useEffect(() => {

    if (isLogin && !hasMockHomeworkBinding()) {
      store.dispatch(PointsActions.fetchPoints());
      store.dispatch(fetchUserPoints2());
    }
  }, [isLogin]);

  return (
    <>
      {scoped?.mode === 'assignment_preview' ? <nav aria-label="教师模考预览" style={{ position: 'fixed', bottom: 8, right: 20, zIndex: 100001, display: 'flex', alignItems: 'center', gap: 12, maxWidth: 'calc(100vw - 40px)', background: '#fff', padding: '10px 16px', border: '1px solid #c7d2fe', borderRadius: 8, boxShadow: '0 2px 10px #ddd' }}>
        <strong>教师只读预览</strong>{' '}
        {(['listening', 'reading', 'writing'] as const).map((course, i) => <button key={course} type="button" style={{ padding: '5px 12px', border: '1px solid #c7d2fe', borderRadius: 4, color: '#2346e8', background: '#f5f7ff', cursor: 'pointer' }} onClick={() => navigate(`/mock${course}/${scoped.recordId}`)}>{['听力', '阅读', '写作'][i]}</button>)}
      </nav> : null}
      <Routes>
        {
          routerConf.map((item) => {
            return <Route key={item.path} path={item.path} Component={item.Component} />;
          })
        }
      </Routes>
      <Toaster containerStyle={{zIndex: 100002}} />
    </>
  );
}

export default App;
